export default __webpack_public_path__ + "static/media/build-icon.856dcfd6.svg";